import React from "react";
import logo from "./Figures/Vectors/logo.svg";

const Footer = () => {
  return (
    <footer className="text-gray-600 body-font">
      <div className="bg-white border-t-2 border-sky-200">
        <div className="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col bg-white">
          <div className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900">
            <img src={logo} alt="My Happy SVG" className="w-14 h-14" />
            <span className="ml-3 text-xl">Βασιλική Μαργαριτοπούλου</span>
          </div>
          <p className="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">
            © 2026 Made by Efstratios Eftychiadis
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
